module.exports = __webpack_public_path__ + "static/media/washingtonpost.com_news_morning-mix_wp_2016_07_21_fla-police-shoot-black-man-with-his-hands-up-as-he-tries-to-help-autistic-patient__plot.b6c57dca.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/washingtonpost.com_news_morning-mix_wp_2016_07_21_fla-police-shoot-black-man-with-his-hands-up-as-he-tries-to-help-autistic-patient__plot.png
// module id = 431
// module chunks = 0